var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.151765 9.22129C-0.224558 11.4107 0.10321 13.663 1.08793 15.6543C2.07265 17.6456 3.66357 19.2733 5.63187 20.3033C7.60017 21.3332 9.84443 21.7124 12.0418 21.3862C14.2392 21.06 16.2766 20.0452 17.8608 18.4879C19.445 16.9306 20.4945 14.9109 20.8583 12.7194C21.222 10.5279 20.8814 8.27748 19.8853 6.29184C18.8891 4.30619 17.2889 2.68764 15.3147 1.66898C13.3406 0.650319 11.0942 0.284044 8.89869 0.622835L9.25524 2.93342C10.9619 2.67006 12.7081 2.95479 14.2427 3.74663C15.7773 4.53848 17.0212 5.79664 17.7955 7.34016C18.5698 8.88368 18.8347 10.633 18.5519 12.3366C18.2691 14.0401 17.4533 15.6101 16.2218 16.8206C14.9904 18.0312 13.4067 18.82 11.6985 19.0736C9.9904 19.3272 8.24585 19.0324 6.71581 18.2318C5.18577 17.4312 3.94909 16.1659 3.18363 14.618C2.41817 13.0701 2.16338 11.3192 2.45591 9.61734L0.151765 9.22129Z",
    fill: "#2D64E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10001 0.500011H4.20001V6.8H2.10001V0.500011Z",
    fill: "#2D64E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 2.60001V4.70001L1.05152e-05 4.70001L1.0607e-05 2.60001L6.3 2.60001Z",
    fill: "#2D64E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9C13.5 10.6569 12.1569 12 10.5 12C8.84315 12 7.5 10.6569 7.5 9C7.5 7.34315 8.84315 6 10.5 6C12.1569 6 13.5 7.34315 13.5 9Z",
    fill: "#2D64E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 19C16.5 15.6863 13.8137 13 10.5 13C7.18629 13 4.5 15.6863 4.5 19L10.5 20L16.5 19Z",
    fill: "#2D64E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.40cb7275c769375fca52b1554407aae9.svg";
export { ForwardRef as ReactComponent };